module.exports = __webpack_public_path__ + "839b7fe2525b0397c0f0dbc713a7aa8e.svg";